/**
 * WordPress dependencies
 */
import { useMemo } from '@wordpress/element';
/**
 * Internal dependencies
 */

import * as styles from '../styles';
import { useContextSystem } from '../../ui/context';
import { useCx } from '../../utils/hooks/use-cx';
export function useBorderBoxControlLinkedButton(props) {
  const {
    className,
    __next36pxDefaultSize = false,
    ...otherProps
  } = useContextSystem(props, 'BorderBoxControlLinkedButton'); // Generate class names.

  const cx = useCx();
  const classes = useMemo(() => {
    return cx(styles.BorderBoxControlLinkedButton(__next36pxDefaultSize), className);
  }, [className, cx, __next36pxDefaultSize]);
  return { ...otherProps,
    className: classes
  };
}
//# sourceMappingURL=hook.js.map